module.exports = __webpack_public_path__ + "static/media/bg9.876271f4.jpg";